import React, { useState } from "react";
import { 
	Button, 
	Grid, 
	makeStyles
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { useForm } from '../../../hooks/useForm';
import CancelIcon from "@material-ui/icons/Cancel";
import ModalAbm from '../../compartidos/abms/ModalAbm';
import { validarSoloUnPermiso } from '../../../helpers/permisos';
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { FormPracticasAgrupadas } from './FormPracticasAgrupadas';

const useStyles = makeStyles({
    botonera: {
        padding: 25
    }
});

export const FormGrupo = ({item, permisosUser, permisoEdit, permisoAlta, cerrarModal, handleSave}) => {
    const classes = useStyles();    

	const [onlyRead, setOnlyRead] = useState(false);
	const [openModal, setOpenModal] = useState(false);

    const FormInicial = {
        nombre: ""
    }

    const [formValues, handleInputChange] = useForm(item ? item : FormInicial);

    const handleSubmit = (e) => {
        e.preventDefault()
        handleSave(formValues);
    };

    return (
        <ValidatorForm onSubmit={handleSubmit}>
            <Grid container style={{ padding: 25 }}>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Nombre"
                        name="nombre"
                        value={formValues.nombre}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem", marginBottom: 50 }}
                        validators={["required"]}
                        errorMessages={["La descripción es requerida"]}
                    />
                </Grid>
				{item?.id &&
					<Grid
						container
						spacing={1}
						direction="row"
						justify="flex-start"
						alignItems="center"
					>
						<Grid item xs={12}>
							<Button
								variant="contained"
								color="primary"
								onClick={() => {setOpenModal(true); setOnlyRead(true);}}
							>
								VER PRÁCTICAS
							</Button>
							{openModal && onlyRead &&
								<ModalAbm title="Ver Prácticas" open={openModal} setOpen={setOpenModal}>
									<FormPracticasAgrupadas grupo={item} handleCloseModal={() => setOpenModal(false)}/>								
								</ModalAbm>
							}
							{validarSoloUnPermiso(permisosUser, permisoEdit) &&
								<>
									<Button
										color="primary"
										variant="contained"
										style={{marginLeft: 50}}
										onClick={() => {setOpenModal(true); setOnlyRead(false);}}
									>
										Modificar PRÁCTICAS
									</Button>
									{openModal && !onlyRead &&
										<ModalAbm title="Modificar Prácticas" open={openModal} setOpen={setOpenModal}>
											<FormPracticasAgrupadas onlyRead={false} grupo={item} handleCloseModal={() => setOpenModal(false)}/>
										</ModalAbm>
									}
								</>
							}
						</Grid>
					</Grid>
				}
                <Grid container className={classes.botonera} >
                    <Grid item xs={12}>
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                        >
                            <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<CancelIcon />}
                                onClick={cerrarModal}
                            >
                                CANCELAR
                            </Button>
                            {
                                (validarSoloUnPermiso(permisosUser, permisoAlta) || validarSoloUnPermiso(permisosUser, permisoEdit)) &&

                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<SaveIcon />}
                                    type='submit'
									style={{marginLeft: 50}}
                                    onClick={cerrarModal}
                                >
                                    GUARDAR
                                </Button>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </ValidatorForm>
    );
};
export default FormGrupo;